import { TimelineMax } from "gsap";
import * as HLF from "html-living-framework";
import {Application} from "../Application";
import { Button } from "../gameobjects/Button";
import {Keyboard} from "../gameobjects/Keyboard";
import {LoadScreen} from "./LoadScreen";

export abstract class AbstractGameState extends HLF.State {
    public homeButton?: Button;
    protected readonly idleTimeline: TimelineMax = new TimelineMax({delay: 8});
    protected idleStartTime?: number;
    protected abstract analyticsScreenName: string;
    protected abstract analyticsRoundName?: string | "Trash Blast" | "Planter Party" | "Lights Out";

    public constructor() {
        super();
        this.idleTimeline.call(() => {
            this.idleTimeline.delay(8);
        });
    }
    public init(pSize: PIXI.Point, pData?: any) {
        super.init(pSize, pData);

        Keyboard.clear();
        Keyboard.enabled = true;
        window.onbeforeunload = () => {
            this.trackEvent("gameQuit", {duration: (new Date().valueOf() - Application.instance.startTime) / 1000});
        };
        const interactionManager: PIXI.InteractionManager = HLF.Application.instance.renderer.plugins.interaction;
        this.onMouseMoved = this.onMouseMoved.bind(this);
        this.onMouseDown = this.onMouseDown.bind(this);
        interactionManager.addListener(HLF.Input.Events.MOUSE_MOVE, this.onMouseMoved); // intentionally doing "mouse" not "pointer", as we only want this on desktop
        interactionManager.addListener(HLF.Input.Events.MOUSE_DOWN, this.onMouseDown); // intentionally doing "mouse" not "pointer", as we only want this on desktop
    }

    public lockScreen() {
        this.interactiveChildren = false;
        Keyboard.enabled = false;
    }

    public unlockScreen() {
        this.interactiveChildren = true;
        Keyboard.enabled = true;
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);
        if (this.homeButton) {
            this.homeButton.scale.set(Math.max(this.homeButton.scale.x, this.homeButton.scale.y));
            this.homeButton.x = ((1024 - pSize.x) / 2) + 108;
            this.homeButton.y = 134.5;
        }
    }

    public destroy() {
        const interactionManager: PIXI.InteractionManager = HLF.Application.instance.renderer.plugins.interaction;
        interactionManager.removeListener(HLF.Input.Events.MOUSE_MOVE, this.onMouseMoved);
        interactionManager.removeListener(HLF.Input.Events.MOUSE_DOWN, this.onMouseDown);
        super.destroy();
    }

    public gotoNextState<T>(name: string, data?: T) {
        this.idleTimeline?.kill();
        this.idleTimeline?.clear();
        Application.instance.voiceover.stopVO();
        PubSub.publishSync(HLF.STOP_CAPTION);
        const steps = [
            HLF.TransitionStep.ShowLoadScreen,
            // HLF.TransitionStep.AnimCurrentOut,
            HLF.TransitionStep.RemoveCurrent,
            HLF.TransitionStep.UnloadAssets,
            HLF.TransitionStep.LoadAssets,
            // HLF.TransitionStep.Pause1Second,
            HLF.TransitionStep.HideLoadScreen,
            HLF.TransitionStep.AttachNewInFront,
            HLF.TransitionStep.AnimNewIn,
        ];
        PubSub.publishSync(
            HLF.STATE_LOAD_STATE, data ?
                new HLF.StateToken({id: name, data}, LoadScreen.NAME, ...steps) :
                new HLF.StateToken(name, LoadScreen.NAME, ...steps),
        );
    }

    protected trackEvent(
        event: "gamePlay" | "gameTimeoutPlay" | "gameTOReEngage" | "gameComponentStart" | "gameComponentComplete" | "gameRoundStart" | "gameRoundComplete" | "gamePlaythroughComplete" | "gameQuit" | "gameAchievement" | "gameMenuClick" | "gameSkip" | "gameQuestionCA" | "gameQuestionWA" | "gameInteraction",
        params?: {[key: string]: string | number},
    ) {
        (window as any).dataLayer = (window as any).dataLayer || [];
        (window as any).dataLayer.push({
            event,
            gameName: "Go Green",
            screenName: this.analyticsScreenName,
            roundName: this.analyticsRoundName,
            language: "English",
            timestamp: (Date.now() / 1000),
            ...params,
        });

        console.log(event, {
            ...params,
            screenName: this.analyticsScreenName,
            roundName: this.analyticsRoundName,
        });
    }

    protected onMouseMoved() {
        if (this.idleTimeline) {
            this.idleTimeline.delay(15);
        }
    }

    protected onMouseDown() {
        if (this.idleTimeline) {
            this.idleTimeline.delay(8);
        }
    }
}
